import { render } from "./DeleteDepotModal.vue?vue&type=template&id=04f72666"
import script from "./DeleteDepotModal.vue?vue&type=script&lang=js"
export * from "./DeleteDepotModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__